import React from 'react';
import SideNavBar from '../../components/SideNavBar/SideNavBar';
import { deleteLeaveData, getLeaveData } from '../../service/adminApi';
import moment from 'moment';
import Popup from '../../components/ConformationPopup/Popup';
import './offboard.css';
import './Leave.css';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Loader from '../../StaticComponent/Loader';

function LeaveWfh() {
    const [leaveData, setLeaveData] = React.useState([]);
    const [editLeaveData, setEditLeaveData] = React.useState({});
    const [flag, setFlag] = React.useState(false);
    const [deleteIndex, setdeleteIndex] = React.useState();
    const [hideContainer, setHideContainer] = React.useState(true);
    const [loading, setLoading] = React.useState(false);

    let breadCrumbsData = [
        { title: 'Dashboard', path: '/Overview', isActive: true },
        { title: 'Admin', path: '/admin/accountbranding', isActive: true },
        { title: 'Leave/WFH Settings', path: '', isActive: false },
    ];

    React.useEffect(() => {
        getLeaveList();
    }, []);

    const getLeaveList = async () => {
        const response = await getLeaveData();

        if (response.data.statusCode === 200) {
            setLeaveData(response.data.data);
            setLoading(true);
        }
    };

    const deleteLeaveTemplate = () => {
        let data = {
            leave_id: leaveData[deleteIndex].id,
            is_active: false,
        };
        deleteLeaveData(data).then((res) => {
            if (res.data.statusCode === 200) {
                let data = leaveData;
                let arr = data.splice(deleteIndex, 1);
                let updatedData = data;
                setLeaveData(updatedData);
                setFlag(!flag);
            }
        });
    };

    const updatedData = (data) => {
        switch (data) {
            case 'cancel':
                setEditLeaveData({});
                break;
            case 'update':
                getLeaveList();
                break;
            default:
                break;
        }
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbsData} />
            {hideContainer == false ? (
                <SideNavBar
                    form="leave"
                    editData={editLeaveData}
                    handleData={(data) => {
                        updatedData(data);
                    }}
                    hideContainer={hideContainer}
                    setHideContainer={() => setHideContainer()}
                />
            ) : null}
            <div className="row mb-5">
                <div className="col-md-12">
                    <div className="d-flex justify-content-between">
                        <h5 className="bold-text tt-bold font-18">Manage Leaves/WFH</h5>
                        <button
                            className="btn hive-btn-primary"
                            type="button"
                            //     data-bs-toggle="offcanvas"
                            //     data-bs-target="#offcanvasRight"
                            //     aria-controls="offcanvasRight"
                            onClick={() => setHideContainer(false)}
                        >
                            <img className="me-2" src="/Images/plus.svg" />
                            New Leave Type
                        </button>
                    </div>
                </div>
                <div className="col-md-3 mt-4 mb-3">
                    <div className="card admin-card-styles border-0 ">
                        <div
                            className="admin-offboard-bg-holder admin-offboard-bg-card admin-offboard-bg-image"
                            style={{
                                backgroundImage: 'url(/Images/card-bg.svg)',
                            }}
                        />
                        {/*/.bg-holder*/}
                        <div className="card-body position-relative mt-3">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <p className="bold-text font-12 mb-0">WFH</p>
                                <span className="leave-count-card">No Limit</span>
                            </div>
                            <p className="regular-text font-12 mb-1 offboard-card-text-trunc">
                                Each employee can avail Work from Home if needed
                            </p>
                            <p className="medium-text font-10 admin-offboard-dateupdate"></p>
                        </div>
                    </div>
                </div>
                {leaveData.map((data, index) => {
                   
                    let m = moment(new Date(data.modified_at));
                    let joinDate = m.format('MMMM DD, YYYY');
                    return (
                        <div className="col-md-3 mt-4 mb-3">
                            <div className="card admin-card-styles border-0 ">
                                <div
                                    className="admin-offboard-bg-holder admin-offboard-bg-card admin-offboard-bg-image"
                                    style={{
                                        backgroundImage: 'url(/Images/card-bg.svg)',
                                    }}
                                />
                                {/*/.bg-holder*/}
                                <div className="card-body position-relative mt-3">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <p className="bold-text font-12 mb-0">{data.type}</p>
                                        <span className="leave-count-card">{data.count} d/yr</span>
                                    </div>
                                    <p className="regular-text font-12 mb-1 offboard-card-text-trunc">{data.description}</p>
                                    <p className="medium-text font-10 admin-offboard-dateupdate">Last Updated : {joinDate}</p>
                                </div>
                                <div class="card-kebab-position">
                                    <img
                                        src="/Images/card_edit.svg"
                                        alt="Icon"
                                        class="m-1"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    />

                                    <ul className="dropdown-menu dropdown-menu-end offboarding-card-dropdown border-0 shadow-sm">
                                        <li>
                                            <button
                                                className="dropdown-item dditems semibold-text font-12 border-bottom touchbase-kebabitems-color border-bottom"
                                                type="button"
                                                data-bs-toggle="offcanvas"
                                                data-bs-target="#offcanvasRight"
                                                aria-controls="offcanvasRight"
                                                onClick={() => {
                                                    setEditLeaveData(leaveData[index]);
                                                    setHideContainer(false);
                                                }}
                                            >
                                                Edit
                                            </button>
                                        </li>
                                        {data.id !== 3 && data.id !== 18 && data.id !== 21 ? (
                                            <li>
                                                <a
                                                    onClick={() => {
                                                        setdeleteIndex(index);
                                                    }}
                                                    className="dropdown-item dditems semibold-text font-12 touchbase-kebabitems-color"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#logout"
                                                >
                                                    Delete
                                                </a>
                                            </li>
                                        ) : null}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            <Popup
                deleteData={() => {
                    deleteLeaveTemplate();
                }}
            />
            <Loader isLoading={loading} />
        </div>
    );
}

export default LeaveWfh;
